import { Button, Tooltip } from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { FC, useState } from 'react';
import { useInstallPrompt } from 'hooks/useInstallPrompt';
import InstallAppDialog from './InstallAppDialog';

const pulseKeyframes = `
  @keyframes installPulse {
    0%   { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.5); }
    70%  { box-shadow: 0 0 0 8px rgba(99, 102, 241, 0); }
    100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0); }
  }
  @media (prefers-reduced-motion: reduce) {
    .install-pulse { animation: none !important; }
  }
`;

const InstallAppButton: FC = () => {
  const { canInstall, isIOS, triggerInstall } = useInstallPrompt();
  const [open, setOpen] = useState(false);

  if (!canInstall) return null;

  return (
    <>
      <style>{pulseKeyframes}</style>
      <Tooltip title="Instalar como aplicativo no seu dispositivo">
        <Button
          aria-label="Adicionar à tela inicial"
          onClick={() => setOpen(true)}
          className="install-pulse"
          startIcon={<PhoneIphoneIcon />}
          sx={{
            background: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)',
            color: '#fff',
            borderRadius: '20px',
            px: 2,
            py: 0.75,
            fontSize: '13px',
            fontWeight: 600,
            textTransform: 'none',
            animation: 'installPulse 2.5s ease-in-out infinite',
            whiteSpace: 'nowrap',
            '&:hover': {
              background: 'linear-gradient(135deg, #4f46e5 0%, #2563eb 100%)',
              transform: 'scale(1.03)',
              boxShadow: '0 4px 16px rgba(99,102,241,0.4)',
            },
            transition: 'transform 150ms ease, box-shadow 150ms ease',
          }}
        >
          Baixar APP
        </Button>
      </Tooltip>
      <InstallAppDialog
        open={open}
        isIOS={isIOS}
        onInstall={triggerInstall}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default InstallAppButton;
